'use client';

import Link from 'next/link';
import { MouseEventHandler, ReactNode } from 'react';
import { GtmEventName } from 'lib/gtm';

interface EligibilityGatedLinkProps {
  href: string;
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  gtmEvent?: Extract<GtmEventName, 'GetStartedClick' | 'BrowsePlanClick'>;
}

export default function EligibilityGatedLink({
  href,
  className,
  children,
  onClick,
  gtmEvent,
}: EligibilityGatedLinkProps) {
  return (
    <Link
      href={href}
      className={className}
      onClick={onClick}
      data-gtm-event={gtmEvent}
    >
      {children}
    </Link>
  );
}
